import { z } from "zod";

export const vendorArticleFormSchema = z.object({
	contactId: z.uuid(),
	identifier: z.string().min(1),
	purchasePrice: z.number().default(0),
});

export type VendorArticleFormSchema = z.infer<typeof vendorArticleFormSchema>;
